export default __webpack_public_path__ + "static/media/ringtone.b6bd6a2c.mp3";